module.exports = __webpack_public_path__ + "static/media/bored-weary.e7c93b0c.png";